import React, { useEffect, useState } from 'react'

import {
  Button,
  Divider,
  Grid,
  makeStyles,
  Tooltip,
  Typography
} from '@material-ui/core'

import { ReactComponent as CarBody } from 'assets/img/car-body-scheme.svg'
import { ReactComponent as CarSalon } from 'assets/img/car-salon-scheme.svg'
import PartStateIcon from 'components/CarTechStateModal/components/PartStateIcon'
import TechStateInfoModal from 'components/CarTechStateModal/components/TechStateInfoModal'
import {
  configBody,
  configSalon
} from 'components/CarTechStateModal/components/config'

import useResErrors from 'hooks/useResErrors'

import CarRepairReport from 'components/CarTechStateModal/components/CarRepairReport'
import { CarService } from 'lib/api'
import { parseJson } from 'lib/utils'
import { Modal } from 'asterX-UI/Modals'
import PageContainer from 'components/PageContainer/PageContainer'
import HeaderBack from 'components/Mobile/HeaderBack'
import { LoaderBackdrop } from 'asterX-UI/Loaders'

const useStyles = makeStyles(() => ({
  rootDiv: {
    position: 'relative',
    display: 'flex'
  }
}))

const CarTechStateModal = ({ open, onClose, vin }) => {
  const classes = useStyles()
  const { standardCheck } = useResErrors()
  const [loading, setLoading] = useState(false)
  const [tempData, setTempData] = useState({ open: false, data: null })
  const [states, setStates] = useState({ body: null, salon: null, akt: null })
  const { body, salon, all } = states

  const getValueTechState = async () => {
    setLoading(true)

    return new Promise((resolve, reject) => {
      CarService.getCarValueByVin(vin).then(response => {
        setLoading(false)

        standardCheck(
          response,
          () => {
            const data = parseJson(response?.data?.value, {})

            data?.inspectionInternalPurch &&
              setStates(prevState => ({
                ...prevState,
                salon: data?.inspectionInternalPurch,
                body: data?.inspectionExternalPurch,
                all: data
              }))

            resolve('park')
          },
          {
            onFail: () => reject('err')
          }
        )
      })
    })
  }

  useEffect(() => {
    getValueTechState()

    return () => {}
  }, [])

  const handleClose = () => onClose()

  const handleOpenInfo = data => () => {
    setTempData(prevState => ({ ...prevState, open: true, data }))
  }

  const handleCloseInfo = () => {
    setTempData(prevState => ({ ...prevState, open: false, data: null }))
  }

  return (
    <Modal fullScreen open={open} scroll={'paper'} onClose={handleClose}>
      <PageContainer
        customHeader={
          <HeaderBack onClick={handleClose}>Тех. состояние</HeaderBack>
        }
      >
        <Grid
          container
          direction={'row'}
          alignItems={'center'}
          justifyContent={'flex-start'}
          spacing={2}
        >
          <Grid item container xs={12} md={6}>
            <Grid item xs={12} md={12}>
              <Typography variant={'h6'}>Кузов</Typography>{' '}
            </Grid>

            <Grid item xs={12} md={12}>
              <Divider />
            </Grid>

            <Grid item xs={12} md={12}>
              <div className={classes.rootDiv}>
                <CarBody style={{ width: '100%' }} />

                {body &&
                  configBody
                    .filter(v => body.hasOwnProperty(v.name))
                    .map(v => (
                      <Tooltip
                        key={`${v.name}_check_tooltip`}
                        title={body[v.name] ? body[v.name]?.name : ''}
                      >
                        <div
                          key={`${v.name}_check`}
                          style={v.style}
                          onClick={handleOpenInfo(body[v.name])}
                        >
                          <PartStateIcon
                            state={body[v.name] ? body[v.name]?.state : null}
                            paint={
                              body[v.name] ? body[v.name]?.paintThickness : null
                            }
                          />
                        </div>
                      </Tooltip>
                    ))}
              </div>
            </Grid>
          </Grid>

          <Grid item container xs={12} md={6}>
            <Grid item xs={12} md={12}>
              <Typography variant={'h6'}>Салон</Typography>{' '}
            </Grid>

            <Grid item xs={12} md={12}>
              <Divider />
            </Grid>

            <Grid item xs={12} md={12}>
              <div className={classes.rootDiv}>
                <CarSalon style={{ width: '100%' }} />

                {salon &&
                  configSalon
                    .filter(v => salon.hasOwnProperty(v.name))
                    .map(v => (
                      <Tooltip
                        key={`${v.name}_check_tooltip_S`}
                        title={salon[v.name] ? salon[v.name]?.name : ''}
                      >
                        <div
                          key={`${v.name}_check_S`}
                          style={v.style}
                          onClick={handleOpenInfo(salon[v.name])}
                        >
                          <PartStateIcon
                            state={salon[v.name] ? salon[v.name]?.state : null}
                            paint={
                              salon[v.name]
                                ? salon[v.name]?.paintThickness
                                : null
                            }
                          />
                        </div>
                      </Tooltip>
                    ))}
              </div>
            </Grid>
          </Grid>

          <Grid item xs={6} md={6}>
            <Button
              variant={'contained'}
              onClick={handleClose}
              size={'small'}
              fullWidth
            >
              Закрыть
            </Button>
          </Grid>

          <Grid item xs={6} md={6}>
            {all && <CarRepairReport value={all} />}
          </Grid>
        </Grid>

        <LoaderBackdrop loading={loading} />

        {tempData.open && (
          <TechStateInfoModal
            open={tempData.open}
            data={tempData.data}
            onClose={handleCloseInfo}
          />
        )}
      </PageContainer>
    </Modal>
  )
}

export default CarTechStateModal
